import React, { forwardRef, useId } from 'react';
import { DateInputProps } from '../types/Input.types';
import { Input } from '@/modules/Input';
import { InputRef } from '@/shared/types/input';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';

export const DateInput = forwardRef<InputRef, DateInputProps>(
  (
    {
      value,
      placeholder = 'Seleccionar fecha',
      isOpen,
      onInputClick,
      onInputChange,
      onInputFocus,
      onInputBlur,
      className = '',
      disabled = false,
      readOnly = false,
      format = 'dd/MM/yyyy',
      label = '',
      size = 'sm',
    },
    ref
  ) => {
    // Generar un ID único para este input
    const uniqueId = useId();
    const handleInputClick = () => {
      if (!disabled) {
        onInputClick();
      }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!disabled && onInputChange) {
        onInputChange(event.target.value);
      }
    };

    const handleInputFocus = () => {
      if (!disabled && onInputFocus) {
        onInputFocus();
      }
    };

    const handleInputBlur = () => {
      if (!disabled && onInputBlur) {
        onInputBlur();
      }
    };

    return (
      <Input
        id={`date-picker-input-${uniqueId}`}
        label={label}
        ref={ref}
        value={value}
        size={size}
        placeholder={placeholder}
        aria-expanded={isOpen}
        onClickExtraSlot={handleInputClick}
        extraSlot={faCalendar}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        className={className}
        disabled={disabled}
        readOnly={true}
        fullWidth
      />
    );
  }
);
